import { So5LeaderboardSeasonality } from '@sorare/core/src/__generated__/globalTypes';
import { SeasonalityIcon } from '@sorare/core/src/atoms/icons/SeasonalityIcon';
import { TextSwitch } from '@sorare/core/src/atoms/inputs/TextSwitch';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { useConfigContext } from '@sorare/core/src/contexts/config';
import { PlayerSearchViewAttributes } from '@sorare/core/src/lib/playerSearchView';

import { useManagePlayerSearchView } from '../useManagePlayerSearchView';

export const SeasonalityToggle = () => {
  const {
    so5: { inSeasonName, allSeasonsName },
  } = useConfigContext();
  const { statsManager, updatePlayerSearchViewAttribute } =
    useManagePlayerSearchView();
  const seasonality = statsManager[PlayerSearchViewAttributes.SEASONALITY];

  const showInSeasonPrices =
    seasonality === So5LeaderboardSeasonality.IN_SEASON;
  return (
    <TextSwitch
      checked={showInSeasonPrices}
      compact
      onChange={() =>
        updatePlayerSearchViewAttribute(
          PlayerSearchViewAttributes.SEASONALITY,
          showInSeasonPrices
            ? So5LeaderboardSeasonality.ALL_SEASONS
            : So5LeaderboardSeasonality.IN_SEASON
        )
      }
      onLabel={
        <Horizontal>
          <SeasonalityIcon seasonality={So5LeaderboardSeasonality.IN_SEASON} />
          {inSeasonName}
        </Horizontal>
      }
      offLabel={
        <Horizontal>
          <SeasonalityIcon
            seasonality={So5LeaderboardSeasonality.ALL_SEASONS}
          />
          {allSeasonsName}
        </Horizontal>
      }
    />
  );
};
